import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=b74d66ea&scoped=true&"
import script from "./Recommendations.vue?vue&type=script&lang=js&"
export * from "./Recommendations.vue?vue&type=script&lang=js&"
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=b74d66ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d66ea",
  null
  
)

export default component.exports